<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      height: '100vh',
      backgroundColor: '#F5F5F5',
      paddingTop: pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="navbar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      opacity-style
      title="提报新品详情"
      @click-left="goBack"
    />
    <div class="new-good-detail">
      <detail-progress :steps="steps"></detail-progress>
      <div class="wrapper">
        <div class="detail">
          <dl v-if="formData.name">
            <dt>名称</dt>
            <dd>{{ formData.name }}</dd>
          </dl>
          <dl v-if="formData.category">
            <dt>分类</dt>
            <dd>{{ formData.category }}</dd>
          </dl>
          <dl v-if="formData.brand">
            <dt>品牌</dt>
            <dd>{{ formData.brand }}</dd>
          </dl>
          <dl v-if="formData.specifications">
            <dt>规格</dt>
            <dd>{{ formData.specifications }}</dd>
          </dl>
          <dl v-if="formData.qrCode">
            <dt>条形码</dt>
            <dd>{{ formData.qrCode }}</dd>
          </dl>
          <dl v-if="formData.monthReq">
            <dt>月需求量</dt>
            <dd>{{ formData.monthReq }}</dd>
          </dl>
          <dl v-if="formData.remark">
            <dt>备注</dt>
            <dd>{{ formData.remark }}</dd>
          </dl>
          <dl v-if="formData.dateStr">
            <dt>提报时间</dt>
            <dd>{{ formData.dateStr }}</dd>
          </dl>
        </div>
        <div v-if="formData.pics && formData.pics.length" class="img-wrapper">
          <img
            v-for="(imgItem, index) in formData.pics"
            :key="index"
            :src="imgItem"
            @click.stop.prevent
          />
        </div>
      </div>
    </div>
    <div v-if="relateSsuId" class="sub-btn" @click="goDetail">查看商品详情</div>
  </page>
</template>

<script>
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { resolveUrlParams } from '@/utils/utils'
import { API } from '@/api'
import DetailProgress from './widget/DetailProgress.vue'
export default {
  components: {
    DetailProgress
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      steps: [],
      relateSsuId: 0,
      formData: {
        name: '',
        category: '',
        brand: '',
        specifications: '',
        remark: '',
        monthReq: '',
        dateStr: '',
        pics: []
      }
    }
  },
  computed: {
    pagePaddingTop() {
      if (!window.matrix.isMiniProgram) {
        if (!window.matrix.isMallApp) {
          return 44 + this.statusBarHeight + 'px'
        }
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    }
  },
  methods: {
    goBack() {
      this.$back()
    },
    init() {
      this.steps = []
      this.relateSsuId = 0
      this.formData = {
        name: '',
        category: '',
        brand: '',
        specifications: '',
        monthReq: '',
        remark: '',
        dateStr: '',
        qrCode: '',
        pics: []
      }
      this.freshData()
    },
    async freshData() {
      const params = resolveUrlParams()
      this.$Loading()
      try {
        const data = await API.newReqGood.getNewGoodReqDetail({
          demand_id: params.reqId
        })
        this.$Loading.hide()
        const demand = data.demand

        this.relateSsuId = demand.ssu_id

        const formData = {
          name: demand.commodity_name,
          category: demand.sale_class1_name,
          brand: demand.brand,
          specifications: demand.specifications,
          remark: demand.remark,
          dateStr: demand.dateStr,
          pics: demand.pictures || [],
          monthReq: demand.monthly_demand,
          qrCode: demand.graphic_code
        }
        Object.assign(this.formData, formData)

        // 进度数据处理
        const steps = (demand.step || []).map(step => {
          if (demand.status === step.status) {
            step.curr = true
            step.active = true
          }
          if (demand.status > step.status) {
            step.active = true
          }
          return step
        })
        this.steps = steps
      } catch (e) {
        console.log('e', e)
        this.$Loading.hide()
        this.$catch(e)
      }
    },
    goDetail() {
      this.$track(this.$trackMap.newGoodReq.toSsu)
      nativeRedirect(nativeRoutes.goodsDetail, {
        id: this.relateSsuId,
        tickReferId: this.$trackMap.newGoodReq.toSsu
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
.new-good-detail {
  height: 0;
  overflow: scroll;

  background-color: #fff;

  flex: auto;
  .wrapper {
    margin-top: 0.13rem;
    overflow: hidden;

    background-color: #fff;

    .detail {
      padding: 0.45rem 0.36rem 0.17rem 0.4rem;
      dl {
        display: flex;

        min-height: 0.5rem;
        margin: 0 0 0.23rem 0;

        line-height: 0.5rem;

        dt {
          width: 1.6rem;

          flex-shrink: 0;

          font-size: 0.34rem;
          color: #000;
        }

        dd {
          flex: 1;

          font-size: 0.32rem;
          text-align: right;
          color: #888;

          word-break: break-word;
        }
      }
    }

    .img-wrapper {
      display: flex;

      margin-bottom: 1.07rem;
      padding-left: 0.26rem;

      img {
        width: 2.2rem;
        height: 1.6rem;

        margin-right: 0.18rem;
      }
    }
  }
}

.sub-btn {
  width: 100%;
  height: 1.08rem;

  background: #0daf52;

  font-size: 0.36rem;
  color: #fff;

  @include flex-row-center;
}
</style>
